import type { ShareFileInput } from './shareFile'

export type { ShareFileInput } from './shareFile'

// Web: files are downloaded with an `<a download>` link instead (see the callers).
const nativeOnly = () => Promise.reject(new Error('Native share sheet only'))

export const shareFile: (input: ShareFileInput) => Promise<void> = () => nativeOnly()

export const blobToBase64: (blob: Blob) => Promise<string> = () => nativeOnly()
